module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcolorbond.net.au/images/splash-500fc261fe7fecc4763958aa9d0d97c8.jpg";